import './_swatch.scss';

export default () => {};
